import React, { useEffect } from 'react'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'


const useStyles = makeStyles(theme => ({
  questionText: {
    fontWeight: '300',
    margin: '16px 0 8px'
  },
  alignPlaceholder: {
    top: '263px',
    left: '517px',
    width: '524px',
    height: '66px'
  },
  textPlaceholder: {
    textshadow: '0px 2px 1px var(--unnamed-color-ffffff)',
    textAlign: 'center',
    font: 'Bold 50px/60px Roboto',
    letterSpacing: '4px',
    color: '#CECECE',
    textShadow: '0px 2px 1px #FFFFFF',
    opacity: 1,
    textTransform: 'uppercase'
  }
}))

const ExamQuestion = ({ questionContent }) => {
  const classes = useStyles()
  const disciplina = questionContent && questionContent.disciplina && questionContent.disciplina.nome
  const numero = questionContent && questionContent.numero

  useEffect(() => {
    window.MathJax.typeset()
  })

  return (
    <Typography gutterBottom variant="body2" component="p" className={classes.questionText}>
      {disciplina && (
        !(questionContent || {}).questao_anulada ? (
          <div dangerouslySetInnerHTML={{
            __html: `${numero ? numero + '-' : ''} [${disciplina}] ${((questionContent || {}).enunciado || '').replace(/<math>|<\/math>/gi, '`')} `
          }} />
        ) : (
            <div>
              <p className={classes.textPlaceholder}>Questão Anulada</p>
              <div dangerouslySetInnerHTML={{ __html: `${numero ? numero + '-' : ''} [${disciplina}] ${((questionContent || {}).enunciado || '').replace(/<math>|<\/math>/gi, '`')}` }} />
            </div>
          )
      )}
    </Typography>
  )
}

export default ExamQuestion
